import { BusinessUnitHierarchyTypes, BusinessUnitTypes } from "types";

export const businessUnitsDdl = [
	// Aurora
	BusinessUnitTypes.Aurora,
	BusinessUnitHierarchyTypes.InsideSales,
	BusinessUnitHierarchyTypes.Legacy,
	BusinessUnitHierarchyTypes.CrossSellOrRetention,
	// BusinessDevelopment
	BusinessUnitTypes.BusinessDevelopment,
	BusinessUnitHierarchyTypes.ISOs,
	BusinessUnitHierarchyTypes.ISVs,
	BusinessUnitHierarchyTypes.ThirdPartyProducts,
	BusinessUnitHierarchyTypes.Associations,
	// Acquisition
	BusinessUnitTypes.Acquisition,
	BusinessUnitHierarchyTypes.NailSoft,
	// OnePayment
	BusinessUnitTypes.OnePayment,
	BusinessUnitHierarchyTypes.InsideSalesOnePayment,
	BusinessUnitHierarchyTypes.LegacyOnePayment,
	BusinessUnitHierarchyTypes.CrossSellOrRetentionOnePayment,
	// VnSystems
	BusinessUnitTypes.VnSystems,
	BusinessUnitHierarchyTypes.InsideSalesVnSystems,
	BusinessUnitHierarchyTypes.LegacyVnSystems,
	BusinessUnitHierarchyTypes.CrossSellOrRetentionVnSystems,
];

export const getBusinessUnitCombinedName = (
	business_unit,
	business_unit_hierarchy,
) => {
	const emptyData = ["none", "", null];

	const businessUnit =
		!emptyData.includes(business_unit) &&
		BusinessUnitTypes.getByName(business_unit)?.displayName;
	const businessUnitHierarchy =
		!emptyData.includes(business_unit_hierarchy) &&
		BusinessUnitHierarchyTypes.getByName(business_unit_hierarchy)
			?.displayName;

	return `${businessUnit || ""}${
		businessUnitHierarchy ? ` - ${businessUnitHierarchy}` : ""
	}`;
};
